import { useQuery } from '@tanstack/react-query';

import { queries } from '../common/api/queryKeys/queries';

export const useMariAppsFailedRequisitions = (groupId?: string) => {
    return useQuery(queries.mariAppsFailedRequisitions.list(groupId));
};
